import { forwardRef } from 'react';
import type { ReactNode, HTMLAttributes } from 'react';
import { ArrowRight } from 'lucide-react';

export interface InfoAlertProps extends HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode;
  children: ReactNode;
  action?: { label: string; onClick: () => void };
}

export const InfoAlert = forwardRef<HTMLDivElement, InfoAlertProps>(
  ({ icon, children, action, className = '', ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="status"
        className={[
          'flex items-start gap-3 rounded-lg border border-info-border bg-info-bg p-3 text-info-text',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...props}
      >
        {icon && (
          <span
            className="flex shrink-0 items-center leading-5"
            aria-hidden="true"
          >
            {icon}
          </span>
        )}
        <div className="flex flex-col gap-1.5">
          <div className="text-sm leading-5">{children}</div>
          {action && (
            <button
              type="button"
              onClick={action.onClick}
              className="inline-flex cursor-pointer items-center gap-1.5 self-start rounded-md px-1.5 py-1 text-sm font-semibold leading-5 text-muted-foreground hover:underline"
            >
              {action.label}
              <ArrowRight size={16} />
            </button>
          )}
        </div>
      </div>
    );
  },
);

InfoAlert.displayName = 'InfoAlert';
